import { render, staticRenderFns } from "./newsEdit.vue?vue&type=template&id=4a444a0e&scoped=true&"
import script from "./newsEdit.vue?vue&type=script&lang=ts&"
export * from "./newsEdit.vue?vue&type=script&lang=ts&"
import style0 from "./newsEdit.vue?vue&type=style&index=0&id=4a444a0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a444a0e",
  null
  
)

export default component.exports